import Button from '../common/Button'
import Select from '../common/Select'
import { PLATFORMS } from '../../utils/websiteHelpers'

const WebsiteConnectionFilters = ({ filters, onFilterChange, onAddClick }) => {
  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex flex-wrap gap-4">
        <div className="min-w-[150px]">
          <Select
            label="Platform"
            options={[{ value: '', label: 'All Platforms' }, ...PLATFORMS]}
            value={filters.platform}
            onChange={(e) => onFilterChange({ ...filters, platform: e.target.value })}
          />
        </div>
        <div className="min-w-[150px]">
          <Select
            label="Status"
            options={[
              { value: '', label: 'All Status' },
              { value: 'true', label: 'Active' },
              { value: 'false', label: 'Inactive' },
            ]}
            value={filters.isActive}
            onChange={(e) => onFilterChange({ ...filters, isActive: e.target.value })}
          />
        </div>
      </div>
      <Button icon="mdi:plus" onClick={onAddClick} className="w-full sm:w-auto">
        Add Connection
      </Button>
    </div>
  )
}

export default WebsiteConnectionFilters
